"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_STYLE = {
    trackColor: 'rgba(0,0,0,0)',
    thumbColor: 'rgba(0,0,0,0.15)',
    size: 8,
    lineCap: 'round',
};
exports.DEFAULT_THEME = {
    // 默认样式
    default: DEFAULT_STYLE,
    // 鼠标 hover 的样式
    hover: {
        thumbColor: 'rgba(0,0,0,0.2)',
    },
};
//# sourceMappingURL=style.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/gui/lib/scroll-bar/style.js
// module id = 1049
// module chunks = 37